var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('b-button',{attrs:{"variant":"outline-secondary"}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"cloud-download","scale":".8"}}),_vm._v("Annual Report")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }